import { lazy, Suspense } from "react";
import {
  Routes,
  Route,
  Outlet,
  NavLink,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Fallback from "../../Fallback";
import { HEIGHT_MENU } from "../../../services/utils";
import { Icon } from "@diemmea/dma-design-system";


const SettingsNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const lastUrl = location.state?.from || "/installations";
  const linkBaseClass = "flex w-full items-center rounded-[8px] px-4 py-3 text-xs font-semibold text-secondaryDark transition-colors hover:bg-[rgba(203,214,226,0.2)]";

  return (
    <div className="hidden w-[250px] shrink-0 border-r border-medal pr-4 py-8 md:block">
      <div className="flex flex-col gap-2">
        <button
          type="button"
          className="flex w-full items-center px-4 py-3 text-left text-xs font-semibold text-secondaryDark"
          onClick={() => navigate(lastUrl)}
        >
          <Icon icon="arrowleftalt" width={16} className="mr-1" />
          <span>Back</span>
        </button>
        <NavLink
          to="/settings/general/backoffice"
          className={({ isActive }) => `${linkBaseClass} ${isActive ? "bg-[rgba(203,214,226,0.2)]" : ""}`}
        >
          Settings
        </NavLink>
        <NavLink
          to="/settings/subscription-add-ons"
          className={({ isActive }) => `${linkBaseClass} ${isActive ? "bg-[rgba(203,214,226,0.2)]" : ""}`}
        >
          Subscription & Add-ons
        </NavLink>
      </div>
    </div>
  )
}

const SettingsLayout = () => {
  return (
    <div
      className="container mx-auto flex"
      style={{ minHeight: `calc(100vh - ${HEIGHT_MENU}px - 64px)` }}
    >
      <SettingsNavbar />
      <div className="min-w-0 flex-1 bg-white px-4 py-8 md:px-12">
        <Outlet />
      </div>
    </div>
  );
};




function SettingsRouter() {
  const SettingsGeneralRouter = lazy(() => import("./General/router"));
  const SubscriptionAddOns = lazy(() => import("./SubscriptionAddOns"));

  return (
    <Routes>
      <Route element={<SettingsLayout />}>
        <Route
          index
          element={<Navigate to="general/backoffice" replace />}
        />
        {/* General */}
        <Route
          path="general/*"
          element={
            <Suspense fallback={<Fallback />}>
              <SettingsGeneralRouter />
            </Suspense>
          }
        />
        <Route
          path="subscription-add-ons"
          element={
            <Suspense fallback={<Fallback />}>
              <SubscriptionAddOns />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}
export default SettingsRouter;
